//App

import { StateDto } from "../app/model/api/types/dto/stateDto";

export class StateViewModel {
  id?: string | null;
  name: string | null;
  description: string | null;
  abbreviation: string | null;
  capital: string | null;
  regionId: Array<string> | null;
  sortValue: number | null;
  isActive: boolean | null;

  constructor(
    id: string | null,
    name: string | null,
    description: string | null,
    abbreviation: string | null,
    capital: string | null,
    regiondId: Array<string> | null,
    sortValue: number | null,
    isActive: boolean | null
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.abbreviation = abbreviation;
    this.capital = capital;
    this.regionId = regiondId;
    this.sortValue = sortValue;
    this.isActive = isActive;
  }

  toDto(): StateDto {
    return {
      id: this.id,
      isActive: this.isActive,
      name: this.name,
      description: this.description,
      abbreviation: this.abbreviation,
      capital: this.capital,
      regionId:
        this.regionId !== null && this.regionId?.length > 0
          ? this.regionId[0]
          : null,
      sortValue: this.sortValue,
    };
  }

  mapFromDto(dto: StateDto): void {
    this.id = dto.id;
    this.isActive = dto.isActive || true;
    this.name = dto.name;
    this.description = dto.description;
    this.abbreviation = dto.abbreviation;
    this.capital = dto.capital;
    dto.regionId !== null
      ? this.regionId?.push(dto.regionId)
      : (this.regionId = null);
    this.sortValue = dto.sortValue;
  }
}
